export default __webpack_public_path__ + "a804996ee8be8111358d79d04da381d6.svg";